'use es6';

import ActionTypes from '../actions/ActionTypes';
import UsageTracker from '../utils/UsageTracker';
export default (() => next => action => {
  switch (action.type) {
    case ActionTypes.GET_RECOMMENDED_LESSONS_RECEIVED:
      UsageTracker.track('interaction', {
        action: 'receive-lesson-recommendations',
        lessonId: action.payload.seedLessonId
      });
      break;
    case ActionTypes.ACHIEVEMENT_CREATE_SUCCEEDED:
      {
        const achievement = action.payload.response.get('achievements').first();
        UsageTracker.track('interaction', {
          action: 'create-achievement',
          language: action.payload.language,
          publicAchievementId: achievement.get('publicId'),
          privacy: achievement.get('visibilityType')
        });
        break;
      }
    default:
      break;
  }
  return next(action);
});